import { ReactNode } from 'react';

interface TypographyProps {
  children: ReactNode;
}

export const Typography = ({ children }: TypographyProps) => {
  return <div className={'space-y-5'}>{children}</div>;
};
